"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wizard = function Wizard(_ref) {
  var _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "wizard-wrapper"
  }, steps.map(function (step, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "wizard-step ".concat(step.completed && 'wizard-completed'),
      key: "step-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "wizard-dot"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "wizard-text"
    }, step.text));
  }));
};

var _default = Wizard;
exports["default"] = _default;